/* eslint-disable dot-notation */
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    ACCOUNT_LINK_BACK_CLICKED,
    LOGIN_BUTTON_CLICK,
    PLATFORM,
    PLATFORM_SCREEN_VIEW,
} from "../../analytics/eventConstants";
import { trackEvent } from "../../analytics/sdkAnalytics";
import Background from "../../components/Background/Background";
import { PLATFORM_SCREEN, SOMETHING_WENT_WRONG, THIRD_PARTY_OTP_STEP1, THIRD_PARTY_VERIFY } from "../../constants/URLConstants";
import Loader from "../../components/Loader/Loader";
import LoaderWithStatus from "../../components/LoaderWithStatus/LoaderWithStatus";
import {
    PHYLLO_EXIT_REASON_EXIT_FROM_PLATFORM,
} from "../../constants/constants";
import { ConfigState } from "../../context/ConfigContext";
import { SDKInstanceState } from "../../context/SdkInstanceContext";
import { SDKParamsState } from "../../context/SdkParmasContext";
import { WorkPlatformDetailsState } from "../../context/WorkPlatformDetailsContext";
import { getFlowURL } from "../../utils/getFlowURL";
import { ReactComponent as CompletedIcon } from "../../assets/images/completed.svg";
import placeholder_profilepic from "../../assets/images/placeholder_profilepic.svg";
import verify_account from "../../assets/images/verify_icon.svg"
import "./ThirdPartyVerification.scss";
import ScreenNavbar from "../../components/ScreenNavbar/ScreenNavbar";
import { isEmpty } from "../../utils/sdk_utils";
import { LoaderWithStatusState } from "../../context/LoaderWithStatusContext";
import { LoaderState } from "../../context/LoaderContext";
import { useGetRedirectAuthFlow } from "../../utils/CustomHooks/useGetRedirectAuthFlow";

function ThirdPartyVerification() {
    const navigate = useNavigate();
    const params = useParams();
    const [platformToVerify, setPlatformToVerify] = useState("");
    const [config, setConfig] = useState({});
    const [logoImagePath, setLogoImagePath] = useState("");
    const { sdkInstance } = SDKInstanceState();
    const { configuration } = ConfigState();
    const { sdkParams } = SDKParamsState();
    const { workplatformDetails } = WorkPlatformDetailsState();
     const [platformDetails] = useState(
      workplatformDetails[params.workplatformid]
      );
    const { loaderWithStatus } = LoaderWithStatusState();
    const isMounted = useRef();
    const { loader, dispatchLoaderContext } = LoaderState();
    const { isConnectLoader } = LoaderWithStatusState();
    const [loaderMsgConfig, setLoaderMsgConfig] = useState({});

     const redirectAuthFlow = useGetRedirectAuthFlow(platformDetails.id, platformDetails.name || null, sdkParams, workplatformDetails);

    useEffect(() => {
      dispatchLoaderContext(false)
    },[])

    const handleVerificationFlow = async () => {
      const [otp, authId] = await redirectAuthFlow("phyllo_otp_flow");
      dispatchLoaderContext(false);
      navigate(`/${THIRD_PARTY_OTP_STEP1}/${params.workplatformid}`, { state: { otp,  authId} });
      
    };

   const goBack = () => {
    navigate(-1);
  };
  

  if (loader) {
        if (isConnectLoader && !isEmpty(loaderMsgConfig)) {
            return <LoaderWithStatus message={loaderMsgConfig.title.replace("{{PlatformName}}", platformToVerify)} platform={platformToVerify} />;
        }
        return <Loader />;
    }

    return (
        <>
            <Background />
            {platformDetails ? (
                <div className="row col-lg-3 col-md-12 col-sm-12 col-12 m-auto white-screen">
                    <ScreenNavbar
                        className=""
                        backURL={-1}
                        screenName={THIRD_PARTY_VERIFY}
                        exitReason={PHYLLO_EXIT_REASON_EXIT_FROM_PLATFORM + platformDetails.name}
                        workplatformDetails={{
                            workplatformId: platformDetails?.id,
                            workplatformName: platformDetails?.name,
                        }}
                    />

                    <div className="row ms-0 platformscreen_main_div">
                        <div className="col-12 text-center ms-0 mt-0">
                            <div className="icon-group-previous">
                                <img src={platformDetails.logo_url} style={{ width: "60px" }} className="m-auto" alt="platform_logo" />
                                <p>{platformDetails.name}</p>
                            </div>
                        </div>
                    </div>

                    <div className="img-container">
                            <img src={verify_account} alt="loading..." />
                        </div>
                    <div className="row col-12 m-auto text-center mb-4">
                    <div className="verify-copy-container">
                    <h2 className="heading-text h2-provious">
                                Verify your account
                            </h2>
                        <p className="btn-verification-text">
                           Verification helps protect your information and keep your data secure
                        </p>
                      </div>
                        
                            <>
                               
                                    <button className="primary-btn mb-2" onClick={handleVerificationFlow}>
                                        Start Verification
                                    </button>
                                

                                <button
                                    className="secondary-btn"
                                    onClick={() => {
                                        goBack();
                                    }}
                                >
                                    Back
                                </button>
                            </>
                    </div>
                </div>
            ) : null}
        </>
    );
}

export default ThirdPartyVerification; 